// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Icon } from 'Olympus/index';

import styles from './AccordionItem.scss';

/**
 * AccordionItem React component.
 */
class AccordionItem extends PureComponent<*, *> {
  tagHtmlRef: Object;
  updateHeight: Function;

  /**
   * Accordion constructor.
   * @param {object} props to constructor.
   * @constructor
   */
  constructor(props: Object) {
    super(props);
    this.state = {
      height: 0
    };

    this.tagHtmlRef = React.createRef();
  }

  /**
   * componentDidMount implementation.
   * @returns {void}.
   */
  componentDidMount() {
    window.addEventListener('resize', this.updateHeight);
    this.updateHeight();
  }

  /**
   * componentWillUnmount implementation.
   * @returns {void}.
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  /**
   * updateHeight function.
   * @returns {void}.
   */
  updateHeight = () => {
    const el = this.tagHtmlRef;

    /* istanbul ignore else */
    if (el) {
      this.setState({ height: el.offsetHeight });
    }
  };

  /**
   * Reference setter
   * @param {Object} element - mounted instance of the component
   * @returns {void}
   */
  setTagHtmlRef = (element: any) => {
    this.tagHtmlRef = element;
  };

  /**
   * componentDidUpdate implementation.
   * @param {object} prevProps - component props
   * @param {object} prevState - component state
   * @returns {void}
   */
  componentDidUpdate() {
    this.updateHeight();
  }

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const {
      isOpen,
      iconClosed,
      iconOpen,
      onClick,
      accordionHeight,
      accordionItemTitle,
      childContent,
      index,
      iconColor,
      iconSize,
      showMoreButton,
      isChildContentClickable
    } = this.props;

    const setIcon = isOpen ? iconOpen : iconClosed;

    // If the heading is being used in an external partnership page then the icon svgs need to
    // be a hardcoded svg passed in the 'iconSvgObject' prop
    const iconProp =
      typeof setIcon === 'object'
        ? { iconSvgObject: setIcon }
        : { iconName: setIcon };

    return (
      <div
        className={classNames(
          isOpen ? styles.Accordion__Open : styles.Accordion__Closed,
          styles.Accordion__Container
        )}
        onClick={
          showMoreButton || !isChildContentClickable
            ? null
            : () => onClick(index)
        }
      >
        <div
          data-cy="accordion-item-header"
          className={styles.Accordion__Header}
          onClick={
            showMoreButton || isChildContentClickable
              ? null
              : () => onClick(index)
          }
        >
          <h3
            className={classNames(styles.Accordion__Opener, 'AccordionOpener')}
          >
            {accordionItemTitle}
          </h3>
          {!showMoreButton && (
            <div className={styles.icon}>
              <Icon
                {...this.props}
                {...iconProp}
                size={iconSize}
                color={iconColor}
              />
            </div>
          )}
        </div>
        <div
          data-cy="accordion-item-content"
          className={styles.Accordion__Content}
          style={{
            height: isOpen ? this.state.height : accordionHeight
          }}
        >
          {childContent}
        </div>
      </div>
    );
  }
}

AccordionItem.propTypes = {
  accordionHeight: PropTypes.number,
  accordionItemTitle: PropTypes.string.isRequired,
  childContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array
  ]),
  index: PropTypes.number.isRequired,
  accordionClass: PropTypes.array,
  extendButtonStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  isHtml: PropTypes.bool,
  isChildContentClickable: PropTypes.bool
};

AccordionItem.defaultProps = {
  accordionHeight: 0,
  isHtml: false,
  showMoreButton: false,
  isChildContentClickable: true
};

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/components/FAQs/Accordion/AccordionItem/AccordionItem.js